"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckMenuItem = void 0;
var React = __importStar(require("react"));
var icons_1 = require("@epic-ui/icons");
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var createStyles_1 = __importDefault(require("@material-ui/core/styles/createStyles"));
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var withStyles_1 = __importDefault(require("@material-ui/core/styles/withStyles"));
var useStyles = makeStyles_1.default(function (_a) {
    var palette = _a.palette, spacing = _a.spacing, transitions = _a.transitions;
    return createStyles_1.default({
        typography: {
            padding: spacing(2),
            // This allows the `noWrap` behavior to work under a flex parent
            width: 0,
            flexGrow: 1,
        },
        icon: {
            margin: "calc(" + spacing(4) + "px - 0.75rem)",
            stroke: palette.text.secondary,
            transition: transitions.create(["fill", "stroke", "color"], {
                duration: transitions.duration.shorter,
            }),
            ".Mui-selected > &": {
                stroke: palette.background.default,
                fill: palette.primary.main,
                color: palette.primary.contrastText,
            },
        },
    });
}, { name: "EuiCheckMenuItem" });
var styles = createStyles_1.default(function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            display: "flex",
            padding: spacing(0, 4, 0, 2),
        },
    });
});
exports.CheckMenuItem = withStyles_1.default(styles, { name: "EuiCheckMenuItem" })(React.forwardRef(function CheckMenuItem(_a, ref) {
    var selected = _a.selected, children = _a.children, props = __rest(_a, ["selected", "children"]);
    var classNames = useStyles();
    return (React.createElement(MenuItem_1.default, __assign({ selected: selected }, props, { ref: ref }),
        selected ? (React.createElement(icons_1.CheckboxChecked, { className: classNames.icon })) : (React.createElement(icons_1.CheckboxUnchecked, { className: classNames.icon })),
        React.createElement(Typography_1.default, { className: classNames.typography, noWrap: true }, children)));
}));
//# sourceMappingURL=CheckMenuItem.js.map